module.exports = __webpack_public_path__ + "img/dining-4.f4006290.png";